import { EntityNotes } from "@modernary/mui/components/note";
import EntityAudits from "@/components/EntityAudits.vue";
import { RouterView, type RouterOptions } from "vue-router";
import { EntityDocuments } from "@modernary/mui/components/document";

const names = {
  complianceActions: "ComplianceAction.ComplianceActions",
  list: "ComplianceAction.ComplianceActionList",
  base: "ComplianceAction.ComplianceActionBase",
  view: "ComplianceAction.ComplianceActionView,",
  new: "ComplianceAction.ComplianceActionNew",
  edit: "ComplianceAction.ComplianceActionEdit",
  notes: "ComplianceAction.ComplianceActionNotes",
  noteEdit: "ComplianceAction.ComplianceActionNoteEdit",
  noteNew: "ComplianceAction.ComplianceActionNoteNew",
  documents: "ComplianceAction.ComplianceActionDocuments",
  documentEdit: "ComplianceAction.ComplianceActionDocumentEdit",
  documentNew: "ComplianceAction.ComplianceActionDocumentNew",
  audit: "ComplianceAction.ComplianceActionAudit",
};

export { names as complianceActionRouteNames };

const complianceActionRoutes: RouterOptions["routes"] = [
  {
    path: "/complianceActions",
    name: names.complianceActions,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Compliance Actions", lookupGroups: ["ComplianceActionType", "ComplianceActionStatus"] },
        component: () => import("@/views/complianceAction/ComplianceActionList.vue"),
      },
      {
        path: "new/:facilityId(\\d+)?",
        component: () => import("@/views/complianceAction/ComplianceActionBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Compliance Action New", isNew: true },
            component: () => import("@/views/complianceAction/ComplianceActionEdit.vue"),
          },
        ],
      },
     {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/complianceAction/ComplianceActionBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Compliance Action View" },
            component: () => import("@/views/complianceAction/ComplianceActionView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Compliance Action Edit", isForm: true },
            component: () => import("@/views/complianceAction/ComplianceActionEdit.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "ComplianceAction Notes" },
            component: {
              render: () => <EntityNotes idField="complianceActionId" routeNamePrefix="ComplianceAction.ComplianceActionNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "ComplianceAction Note Edit", isForm: true },
            component: () => import("@/views/complianceAction/ComplianceActionNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "ComplianceAction Note New", isForm: true },
            component: () => import("@/views/complianceAction/ComplianceActionNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "ComplianceAction Documents" },
            component: {
              render: () => <EntityDocuments idField="complianceActionId" routeNamePrefix="ComplianceAction.ComplianceActionDocument" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "ComplianceAction Document Edit", isForm: true },
            component: () => import("@/views/complianceAction/ComplianceActionDocument.vue"),
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "ComplianceAction Document New", isForm: true },
            component: () => import("@/views/complianceAction/ComplianceActionDocuments.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "ComplianceAction Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="ComplianceAction" />,
            },
          },
         ],
       },
    ],
  },
];
export default complianceActionRoutes;
